import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEye, faSearchDollar } from "@fortawesome/free-solid-svg-icons"
import { COLORS } from "../../utilities/Constants"
import { generalStyles } from "../styles/styles"
import { complementAdresseToListString } from "../../utilities/Addons"
import {
	ENTITE_TYPE_PERSONNE_PHYSIQUE,
	ENTITE_TYPES_DICT,
} from "../dashboard/entite/Entite"
// Primitives partagées des cartes de référence (extraites d'ici pour servir
// aussi la location — même modèle UI sur les 3 fiches).
import { RefRow, RefSection } from "../others/RefCardV2"

/**
 * Carte de référence (lecture seule) fusionnant Client + Véhicule en une seule
 * carte. `height: 100%` pour s'aligner en hauteur sur la carte « Informations
 * fiche » voisine (grid en align-items stretch).
 *
 * - `entite` : form.entite ; `vehicule` : véhicule sélectionné ou null.
 * - `isSvp` : masque le châssis pour les fiches SVP.
 * - `adresse` : complément d'adresse (memo) ou null.
 * - `onVoirClient` : callback d'ouverture de la fiche client, ou null si masqué.
 * - `onAssocierClient` : fiche en client de passage → bouton « Associer un
 *   client » (GE-67), ou null si masqué.
 * - `onVoirVehicule` : fiche d'entretien → œil ouvrant le véhicule du parc
 *   (parties, détails, documents), ou null si masqué.
 */
const AtelierClientVehiculeCardV2 = ({
	entite,
	vehicule,
	isSvp,
	partieLabel,
	adresse,
	onVoirClient,
	onAssocierClient = null,
	onVoirVehicule = null,
}) => (
	<div style={{ ...generalStyles.card, height: "100%" }}>
		<RefSection
			title="Client"
			action={
				<>
					{entite.is_mauvais_payeur && (
						<FontAwesomeIcon
							icon={faSearchDollar}
							title="Mauvais payeur"
							style={{ color: COLORS.danger }}
						/>
					)}
					{onAssocierClient && (
						<button
							type="button"
							style={{
								...generalStyles.btnSecondary,
								padding: "4px 10px",
								fontSize: 12.5,
								whiteSpace: "nowrap",
							}}
							onClick={onAssocierClient}
						>
							Associer un client
						</button>
					)}
					{onVoirClient && (
						<button
							type="button"
							title="Voir le client"
							style={generalStyles.iconBtn(COLORS.text)}
							onClick={onVoirClient}
						>
							<FontAwesomeIcon icon={faEye} />
						</button>
					)}
				</>
			}
		>
			{entite.type === ENTITE_TYPE_PERSONNE_PHYSIQUE ? (
				<>
					<RefRow label="Nom" value={entite.nom} />
					<RefRow label="Prénom" value={entite.prenom} />
					<RefRow label="Tél" value={entite.telephone} />
					<RefRow label="E-mail" value={entite.email} />
				</>
			) : (
				<>
					<RefRow label="Nom" value={entite.label} />
					{!isSvp && (
						<RefRow
							label="Type"
							value={ENTITE_TYPES_DICT[entite.type]}
						/>
					)}
					<RefRow label="Tél" value={entite.telephone} />
					<RefRow label="E-mail" value={entite.email} />
				</>
			)}
			{adresse && (
				<RefRow
					label="Adresse"
					value={
						<>
							{complementAdresseToListString(adresse)[0]}
							<br />
							{complementAdresseToListString(adresse)[1]}
						</>
					}
				/>
			)}
		</RefSection>

		<RefSection
			title="Véhicule"
			divider
			action={
				onVoirVehicule && vehicule ? (
					<button
						type="button"
						title="Voir / modifier le véhicule"
						style={generalStyles.iconBtn(COLORS.text)}
						onClick={onVoirVehicule}
					>
						<FontAwesomeIcon icon={faEye} />
					</button>
				) : null
			}
		>
			{vehicule ? (
				<>
					<RefRow label="Plaques" value={vehicule.plaques} />
					<RefRow label="Marque" value={vehicule.marque} />
					<RefRow label="Modèle" value={vehicule.modele} />
					{!isSvp && (
						<RefRow label="Châssis" value={vehicule.chassis} />
					)}
					{partieLabel && (
						<RefRow label="Partie" value={partieLabel} />
					)}
				</>
			) : (
				<div style={{ fontSize: 13, color: COLORS.textMuted }}>
					Aucun véhicule sélectionné.
				</div>
			)}
		</RefSection>
	</div>
)

export default AtelierClientVehiculeCardV2
